/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Scene_DescriptionInputs */



/**
* | output |
* | --- |
* | "SCENE DESCRIPTION" |
*
* @param {Ccsl_Export_Header_Scene_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_scene_description = /** @type {((inputs?: Ccsl_Export_Header_Scene_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Scene_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DESCRIPTION DE LA SCENE")
	if (locale === "de") return /** @type {LocalizedString} */ ("Szenenbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("DESCRIZIONE DELLA SCENA")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ОПИСАНИЕ СЦЕНЫ")
	if (locale === "es") return /** @type {LocalizedString} */ ("DESCRIPCIÓN DE LA ESCENA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("场景描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シーンの説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दृश्य का विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("DESCRIÇÃO DA CENA")
	return /** @type {LocalizedString} */ ("SCENE DESCRIPTION")
});